import React, { useEffect } from "react";
import Bowser from "bowser";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { CloseButton } from "components/common/Toast";
import { AuthProvider } from "providers/AuthProvider"; // Import de AuthProvider
import { ThemeProvider } from "providers/ThemeProvider"; // Import du ThemeProvider
import { MsalProvider } from "@azure/msal-react"; // Import MsalProvider from MSAL
import { msalConfig } from "config"; // Import MSAL config
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.scss";
import { PublicClientApplication } from "@azure/msal-browser"; // Import the MSAL instance

const App = () => {
  const HTMLClassList = document.getElementsByTagName("html")[0].classList;

  useEffect(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const HTMLClassList = document.documentElement.classList;

    if (browser.getOSName() === "Windows") {
      HTMLClassList.add("windows");
    }
    if (browser.getBrowserName() === "Chrome") {
      HTMLClassList.add("chrome");
    }
    if (browser.getBrowserName() === "Firefox") {
      HTMLClassList.add("firefox");
    }
    if (browser.getBrowserName() === "Safari") {
      HTMLClassList.add("safari");
    }
  }, [HTMLClassList]);

  useEffect(() => {
    return () => HTMLClassList.remove("double-top-nav-layout");
  }, []);

  // Create MSAL instance and pass it to MsalProvider
  const msalInstance = new PublicClientApplication(msalConfig);

  return (
    <MsalProvider instance={msalInstance}>
      {" "}
      {/* Provide MSAL instance here */}
      <ThemeProvider>
        {" "}
        {/* ThemeProvider pour gérer le contexte thème */}
        <AuthProvider>
          {" "}
          {/* AuthProvider enveloppe l'ensemble de l'application */}
          <>
            <Outlet />
            <ToastContainer
              closeButton={CloseButton}
              icon={false}
              position="bottom-left"
            />
          </>
        </AuthProvider>
      </ThemeProvider>
    </MsalProvider>
  );
};

export default App;
